import { fromFetch } from 'rxjs/fetch';

import { AuthHeaders } from '../../../models/auth-headers';
import { requiredHeaders } from '../../../models/required-headers';
import { ignoreData } from '../../../utils/ignore-data';
import { authwsEnvironment } from '../authws-environment';

/**
 * Change an Authenticated User's password
 * @param existingPassword Existing Password
 * @param newPassword New Password
 * @param alias Account Alias (Optional)
 */
export function postPasswordChange(
  this: unknown,
  request: {
    alias?: string;
    existingPassword: string;
    newPassword: string;
  }
) {
  return fromFetch(
    new Request(authwsEnvironment.resolve(this).passwordChangeUrl, {
      method: 'POST',
      headers: {
        ...requiredHeaders,
        ...new AuthHeaders(),
      },
      body: JSON.stringify(request),
    })
  ).pipe(ignoreData());
}
